import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import MaintanceDeptStatContainer from '../../containers/maintance_dept_stat/MaintanceDeptStatContainer';

const MaintanceDeptStatViewPage = () => {
  return (
    <div>
      <BreadcrumbsContainer
        title="통계/수주관리/유지보수 통계"
        icon="statistics"
      />
      <MaintanceDeptStatContainer />
    </div>
  );
};

export default MaintanceDeptStatViewPage;
